// The task pane (TaskPanelsController, task_panels/_panel) opens in the
// detail-modal sidebar of whichever view is on screen: the outline, the board,
// the mind map or the galaxy. Each hands detail-modal a trigger carrying the
// pane's URL - a never-repeated one, because detail-modal caches panels per
// URL and the pane is live data.
//
// Window events between the pane (task_pane_controller.js) and the views:
//
//   jane:task-pane-open            { taskId, section }  open a task's pane (a
//                                  subtask or the parent, from inside a pane)
//   jane:task-completed-changed    { taskId, completed } the pane completed or
//                                  reopened a task without the outline's help;
//                                  the board, mind map and galaxy repaint it
export function taskPaneTrigger(taskId, section = "details", extra = {}) {
    const params = new URLSearchParams({ section, ...extra, _: String(Date.now()) })
    const trigger = document.createElement("a")
    trigger.dataset.detailUrl = `/tasks/${encodeURIComponent(taskId)}/panel?${params}`
    return trigger
}

// For the views other than the outline: answer the pane's "open this task"
// and "this task was completed" events while `controller` is connected.
// Returns the cleanup for disconnect().
export function hostTaskPane(controller, { onCompleted } = {}) {
    const onOpen = (event) => {
        const { taskId, section } = event.detail || {}
        if (!taskId || event.detail.handled) return
        event.detail.handled = true
        controller.dispatch("open-detail", { detail: { trigger: taskPaneTrigger(taskId, section || "details") } })
    }
    const onDone = (event) => {
        const { taskId, completed } = event.detail || {}
        if (taskId != null && onCompleted) onCompleted(String(taskId), Boolean(completed))
    }
    window.addEventListener("jane:task-pane-open", onOpen)
    window.addEventListener("jane:task-completed-changed", onDone)
    return () => {
        window.removeEventListener("jane:task-pane-open", onOpen)
        window.removeEventListener("jane:task-completed-changed", onDone)
    }
}
